<!--
 * @Author: zhujuan
 * @Date: 2022-01-17 11:08:28
 * @LastEditors: dyl
 * @LastEditTime: 2024-08-01 13:44:51
 * @Description: 
 * @FilePath: /nqc-pc-ui/src/common/components/PopoverNurse/module/AddNurse.vue
-->
<template>
  <div class="popover-content">
    <div class="popover-warp-title">{{row.title || '质控人员选择'}}</div>
    <div v-show="currentPersons.length > 0" class="tag-warp">
      <div class="tag-panel" :class="{ collapse: isCollapse }">
        <w-tag
          v-for="(tag, index) in currentPersons"
          :key="index"
          closable
          @close="handleClose(tag, index)"
        >
          {{ tag.Name1 }}
        </w-tag>
      </div>
      <div
        v-show="currentPersons.length > 4"
        class="tag-arrow"
        @click="isCollapse = !isCollapse"
      >
        折叠
        <i
          class="w-icon-arrow-bottom"
          :class="{ 'w-icon-arrow-top': isCollapse }"
        ></i>
      </div>
    </div>
    <div class="popup-search full flex flex-between">
      <div v-show="!hiddenOtherOrg" class="popup-search-left">
        <w-checkbox v-model="isSingleWard" @change="fetchData(1)">{{
          showText
        }}</w-checkbox>
      </div>
      <div class="popup-search-right">
        <w-input
          v-model="listQuery.Query"
          suf-append="button"
          placeholder="姓名、拼音首拼、工号"
          clearable
          @keyup.enter.native="fetchData(1)"
        >
          <template slot="suf-append">
            <i
              class="w-icon-search expand-range"
              style="width: 34px"
              @click="fetchData(1)"
            ></i>
          </template>
        </w-input>
      </div>
    </div>

    <WnTable :list-query.sync="listQuery" @fetchData="fetchData">
      <w-table
        ref="multiTable"
        :data="tableData"
        border
        :height="269"
        :header-row-class-name="isSingle ? 'hideCheckBox' : ''"
        @select="handleselectRow"
        @select-all="handleselectAll"
      >
        <w-table-column
          type="selection"
          width="50"
          :selectable="checkSelectable"
        ></w-table-column>
        <w-table-column prop="Name" label="姓名" width="110"></w-table-column>
        <w-table-column prop="ID" label="工号" width="90"></w-table-column>
        <w-table-column prop="KSName" label="科室" show-overflow-tooltip>
        </w-table-column>
        <w-table-column prop="BQName" label="病区" show-overflow-tooltip>
        </w-table-column>
      </w-table>
    </WnTable>
  </div>
</template>

<script>
import WnTable from '@/common/components/WnTable'
import _ from 'lodash'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'AddNurse',
  components: { WnTable },
  props: {
    keyNames: {
      type: Object,
      default: () => {}
    },
    row: {
      type: Object,
      default: () => {}
    },
    selectAllFlag: {
      type: Number,
      default: () => 0
    },
    isSingle: {
      type: Boolean,
      default: () => false
    },
    disabledArr: {
      type: Array,
      default: () => {
        return []
      }
    },
    dataList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      isSingleWard: true,
      isCollapse: false,
      hiddenOtherOrg: true,
      currentPersons: [],
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        Query: ''
      },
      OrgId: '',
      tableData: [],
      selectFlag: 0,
      showText: '仅查看本病区'
    }
  },
  computed: {
    ...mapState('check', ['Zkjb'])
  },
  watch: {
    row(val) {
      this.fetchData()
      const defaultValue = val[this.keyNames.values]
      const defaultLabel = val[this.keyNames.labels]
      this.currentPersons = []
      const table = this.$refs.multiTable
      table.clearSelection()
      if (_.isEmpty(defaultValue) || _.isEmpty(defaultLabel)) {
        return
      }

      for (let i = 0; i < defaultValue.length; i++) {
        let obj = {
          ID: defaultValue[i],
          Name: defaultLabel[i],
          Name1: defaultLabel[i].includes(')')
            ? defaultLabel[i]
            : defaultLabel[i] + '(' + defaultValue[i] + ')'
        }
        this.currentPersons.push(obj)
      }
      this.currentPersons.map((v) => {
        const obj = this.tableData.find((o) => o.ID === v.ID && !o.disabled)
        if (obj) {
          this.$nextTick(() => {
            if (table) {
              table.toggleRowSelection(obj, true)
            }
          })
        }
      })
    }
  },
  mounted() {
    // if (this.currentPersons.length === 0 && this.row.defaultValue.length > 0) {
    //   const defaultValue = Array.isArray(this.row.defaultValue)?this.row.defaultValue:this.row.defaultValue.split(',')
    //   const defaultKey = Array.isArray(this.row.defaultKey)?this.row.defaultKey:this.row.defaultKey.split(',')
    //   for (let i = 0; i < defaultValue.length; i++) {
    //     let obj = {
    //       ID: defaultValue[i],
    //       Name: defaultKey[i]
    //     }
    //     this.currentPersons.push(obj)
    //   }
    // }
    this.$nextTick(() => {
      this.$refs.multiTable.doLayout()
    })
  },

  created() {
    this.selectFlag = this.selectAllFlag
    const _self = this
    this.OrgId = this.row.OrgId
    this.hiddenOtherOrg = this.row.SFZKZ == '1' ? true : false
    _self.fetchData()
    if (this.row[this.keyNames.values].length == 0) return
    // 没有默认数组，自己拼接id和name
    const defaultValue = this.row[this.keyNames.values]
    const defaultLabel = this.row[this.keyNames.labels]
    for (let i = 0; i < defaultValue.length; i++) {
      let obj = {
        ID: defaultValue[i],
        Name: defaultLabel[i],
        Name1: defaultLabel[i].includes(')')
          ? defaultLabel[i]
          : defaultLabel[i] + '(' + defaultValue[i] + ')'
      }
      this.currentPersons.push(obj)
    }
  },
  methods: {
    ...mapActions('plan', ['GetUserInfo']),
    // 查询 列表
    fetchData(pageNum) {
      if (pageNum) {
        this.selectFlag = this.selectAllFlag
        this.listQuery.pageNum = pageNum
      }
      console.log(111112)
      const params = {
        OrgId: this.isSingleWard ? this.row.JCFW_DM : '',
        Zkjb: this.row.ZKJB,
        Query: this.listQuery.Query,
        pageIndex: this.listQuery.pageNum,
        pageSize: this.listQuery.pageSize,
        isSearchZRR: this.keyNames.values == 'ZRRDM'
      }
      if (this.row.type == 'checkForHs') {
        //用于检查中的被检查护士和责任人
        this.$requestApi('GetHSList', {
          OrgId: this.isSingleWard ? this.row.JCFW_DM : '',
          pageIndex: this.listQuery.pageNum,
          pageSize: this.listQuery.pageSize,
          Query: this.listQuery.Query
        }).then((res) => {
          this.listQuery.total = res.total
          if (res.data) {
            res.data.forEach((item) => {
              item.Name1 = item.Name + '(' + item.ID + ')'
            })
          }
          this.tableData = res.data
          const table = this.$refs.multiTable
          //this.checkAll()
          this.currentPersons.map((v) => {
            const obj = this.tableData.find((o) => o.ID === v.ID && !o.disabled)
            if (obj) {
              this.$nextTick(() => {
                if (table) {
                  table.toggleRowSelection(obj, true)
                }
              })
            }
          })
        })
      } else if (this.row.type == 'checkForJcz') {
        this.$requestApi('GetCheckUser', {
          OrgId: this.isSingleWard ? this.row.JCFW_DM : '',
          CFXH: this.row.CFXH,
          pageIndex: this.listQuery.pageNum,
          pageSize: this.listQuery.pageSize,
          Query: this.listQuery.Query
        }).then((res) => {
          if (res.success) {
            this.tableData = res.data.map((item) => {
              return {
                Name: item.NAME,
                Name1: item.NAME + '(' + item.ID + ')',
                ID: item.ID,
                BQName: item.BQ_MC,
                KSName: item.KS_MC
              }
            })
            this.listQuery.total = res.total
            this.checkAll()
          }
        })
      } else {
        this.GetUserInfo(params).then((res) => {
          this.listQuery.total = res.total
          res.data.forEach((item) => {
            item.Name1 = item.Name + '(' + item.ID + ')'
          })
          this.tableData = res.data
          const table = this.$refs.multiTable
          this.currentPersons.map((v) => {
            const obj = this.tableData.find((o) => o.ID === v.ID)
            if (obj) {
              this.$nextTick(() => {
                table.toggleRowSelection(obj, true)
              })
            }
          })
        })
      }

      if (this.row.type == 'checkForJcz') {
        this.showText = '仅查看本督查部门'
      }
    },
    checkAll() {
      if (this.selectFlag == 1) {
        // 被查护士用 GetHSList
        this.$requestApi('GetCheckUser', {
          OrgId: this.isSingleWard ? this.row.JCFW_DM : '',
          pageIndex: 1,
          pageSize: 9999,
          Query: this.listQuery.Query
        }).then((res) => {
          res.data.forEach((item) => {
            // item.Name1 = item.Name + '(' + item.ID + ')'
            item.Name1 = item.UserName + '(' + item.ID + ')'
          })
          let allTableData = res.data
          this.currentPersons = []
          allTableData.forEach((item) => {
            if (
              !this.disabledArr.find((i) => i == item.ID) &&
              !this.currentPersons.find((i) => i.ID == item.ID)
            ) {
              this.currentPersons.push(item)
            }
          })
          this.$nextTick(() => {
            this.tableData.forEach((item) => {
              if (!this.disabledArr.find((i) => i == item.ID)) {
                this.$refs.multiTable.toggleRowSelection(item, true)
              }
            })
            this.$emit('confirm', true)
          })
        })
      } else if (this.selectFlag == 2) {
        this.$refs.multiTable.clearSelection()
        this.currentPersons = []
        this.$emit('confirm', true)
        this.selectFlag = 0
      }
    },
    checkSelectable(row) {
      return this.disabledArr.find((i) => i == row.ID) ? false : true
    },

    //更换勾选
    handleselectRow(selection, row) {
      this.selectFlag = 0
      if (this.isSingle) {
        this.tableData.forEach((item) => {
          this.$nextTick(() => {
            this.$refs.multiTable.toggleRowSelection(
              item,
              item.ID == row.ID && selection.find((i) => i.ID == row.ID)
                ? true
                : false
            )
          })
        })
        // selection.filter((i) => i.ID == row.ID)
      }
      const index = this.currentPersons.findIndex((o) => o.ID === row.ID)
      if (index > -1) {
        this.currentPersons.splice(index, 1)
      } else {
        this.isSingle
          ? (this.currentPersons = [row])
          : this.currentPersons.push(row)
      }
    },
    //全选
    handleselectAll(selection) {
      this.selectFlag = 0
      if (selection.length === 0) {
        this.tableData.forEach((row) => {
          const index = this.currentPersons.findIndex((o) => o.ID === row.ID)
          if (index > -1) {
            this.currentPersons.splice(index, 1)
            this.$nextTick(() => {
              this.$refs.multiTable.toggleRowSelection(row, false)
            })
          }
        })
      } else {
        selection.forEach((row, $idx) => {
          const index = this.currentPersons.findIndex((o) => o.ID === row.ID)
          if (index === -1) {
            this.currentPersons.push(row)
            this.$nextTick(() => {
              this.$refs.multiTable.toggleRowSelection(row, true)
            })
          }
        })
      }
    },

    //通过ID获取name1
    getPersonName() {
      let detail = JSON.parse(JSON.stringify(this.row))
      let labels = []
      let values = []
      this.currentPersons.map((v) => {
        labels.push(v.Name1)
        values.push(v.ID)
      })
      detail[this.keyNames.values] = values
      detail[this.keyNames.labels] = labels
      return detail
    },
    // tab 删除
    handleClose(item, index) {
      this.selectFlag = 0
      this.currentPersons.splice(index, 1)
      this.$emit('cancelSelect')
      const table = this.$refs.multiTable
      if (this.tableData.filter((o) => o.ID === item.ID).length > 0) {
        this.$nextTick(() => {
          table.toggleRowSelection(
            this.tableData.find((i) => i.ID == item.ID),
            false
          )
        })
      }
    },
    //折叠查看全部选中
    showCollapse() {
      this.isCollapse = true
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../PopoverPerson/style.scss';
.popover-content {
  width: 580px;
  // height: 380px;
}
/deep/ .hideCheckBox {
  .w-checkbox__inner {
    display: none !important;
  }
}

.popup-search {
  /deep/.is-button {
    padding: 0px !important;
  }
  .expand-range {
    width: 34px;
  }
}
</style>
